export const correoAId = (correo) =>{

    let noBajo = correo.replaceAll('@', '_')
    let noMedio = noBajo.replaceAll('.', '-')

    return noMedio
}